export default __webpack_public_path__ + "static/media/arrow.e52b523b.png";